import { useGetSettlementMethodsQuery } from "@/generated/redux/services/generated/api";
import { useCustomerAccount } from "@/providers";

// Stable empty fallback so consumers that memoize on these arrays don't
// recompute every render while the query is loading.
const EMPTY_LIST: readonly never[] = [];

/**
 * Hook to fetch settlement methods (deposit options) from the BFF.
 * Returns fiat bank accounts and blockchain wallets available for deposits.
 *
 * Filters out fiat methods when the customer account does not have currencies
 * enabled (hasCurrencies === false), and blockchain methods when digital
 * assets are disabled (hasDigitalAssets === false).
 */
export function useSettlementMethods() {
  const { customerAccount, hasDigitalAssets, hasCurrencies } =
    useCustomerAccount();
  const customerAccountId = customerAccount?.customerAccount?.id;

  const { data, isLoading, isError, refetch } = useGetSettlementMethodsQuery(
    { customerAccountId: customerAccountId as string },
    { skip: !customerAccountId }
  );

  return {
    fiat: hasCurrencies
      ? (data?.fiat ?? (EMPTY_LIST as never[]))
      : (EMPTY_LIST as never[]),
    blockchain: hasDigitalAssets
      ? (data?.blockchain ?? (EMPTY_LIST as never[]))
      : (EMPTY_LIST as never[]),
    isLoading,
    isError,
    refetch,
  };
}
